import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type IgPreviewTab = 'comments' | 'dm';

@Component({
  selector: 'globot-instagram-phone-preview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './instagram-phone-preview.component.html',
  styleUrls: ['./instagram-phone-preview.component.scss'],
})
export class InstagramPhonePreviewComponent {
  @Input() username: string = 'tu.cuenta';
  @Input() profilePictureUrl: string = '';
  @Input() dmMessage: string = '';
  @Input() sendDm: boolean = true;
  @Input() sendPublicReply: boolean = false;
  @Input() publicReplyMessage: string = '';

  activeTab: IgPreviewTab = 'comments';

  setTab(tab: IgPreviewTab): void {
    this.activeTab = tab;
  }
}
